import styled, { css } from 'styled-components';

export const StyledInputContainer = styled.div(
  ({ theme }) => css`
    width: 100%;
    .radio-input {
      opacity: 0;
      height: 0;
      width: 0;
      position: absolute;
    }
    .radio-input + label {
      border: 1px solid ${theme.mediumGray};
      border-radius: 3px;
      cursor: pointer;
      font-size: ${theme.fontSizes.lg};
      white-space: nowrap;
      min-height: 8.125rem;
      @media (max-width: ${theme.screenSizes.laptopS}) {
        font-size: 1.125rem;
      }

      .visual-radio {
        width: 25px;
        height: 25px;
        display: inline-block;
        border: 4px solid ${theme.white};
        box-shadow: 0 0 0 1px ${theme.primaryBlue};
        border-radius: 50%;
      }
    }
    .radio-input:checked + label {
      box-shadow: inset 0 0 0 2px ${theme.primaryBlue};
      font-weight: ${theme.fontWeights.fontHeavy};
      letter-spacing: -0.3px;
      .visual-radio {
        background-color: ${theme.primaryBlue};
      }
    }
    .radio-input:focus + label {
      box-shadow: inset 0 0 0 2px ${theme.primaryBlue};
      .visual-radio {
        box-shadow: 0 0 0 2px ${theme.primaryBlue};
      }
    }
  `,
);
